import React from 'react';

function UpdateEncryptionKey() {
  return <div>UpdateEncryptionKey</div>;
}

export default UpdateEncryptionKey;
